<template>
    <div class="content">
        <div class="my-title">
            <Row :gutter="10">
                <Col :span="18">我的任务</Col>
                <Col :span="6">
                    <Select v-model="params.bizId" disabled>
                        <Option value="JIANGONG_EMPLOYER_LIABILITY">建工雇主</Option>
                        <Option value="JIANGONG_DEPOSIT">建工投标保证金 </Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <Tabs v-model="params.workBenchType" @on-click="changeTab">
            <TabPane label="待办" name="TO_BE_AUDITED"></TabPane>
            <TabPane label="进行中" name="APPLY_PROCESSING"></TabPane>
        </Tabs>
        <div class="orders">
            <i-table :columns="columns" url="/workbench/list.admin" :params="params" ref="table">
                <template slot-scope="{ row,index }" slot="action">
                    <a v-if="row.taskId" @click="toEdit(row)">办理</a>
                    <a v-else @click="toDetail(row)">查看</a>
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import PolicyItem from '../common/PolicyItem'
    import ITable from '@/components/common/ITable'
    import { getAgentUrl } from '@/common/agent'
    import { mapState } from 'vuex'
    export default {
        components: { PolicyItem, ITable },
        data () {
            return {
                params: {
                    workBenchType: 'TO_BE_AUDITED',
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                    workFlowType: 'BUILDER_EMPLOYER',
                },
                // status:'TO_BE_AUDITED',
                columns: [
                    { title: '单号', key: 'associateNo' },
                    { title: '节点', key: 'currentTaskName' },
                    // {title:'状态',key:'statusShow',width:100},
                    { title: '提交日期', key: 'startTime', width: 180 },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center'
                    }
                ],
                list: {},
                loading: false,
            }
        },
        watch: {
            userInfo (v) {
                this.checkLogin()
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.common.info
            }),
        },
        created () {
            if (this.checkLogin()) {
                if (this.$route.query.status) this.params.workBenchType = this.$route.query.status
                else this.params.workBenchType = 'TO_BE_AUDITED'
            }
        },
        methods: {
            changeTab (val) {
                this.status = val
                this.params.workBenchType = val
                this.$refs.table.getList()
            },
            async toEdit (data) {
                if (this.loading) return false
                this.loading = true
                let url = ''
                if (data.workFlowType == 'BUILDER_EMPLOYER_POLICY') { //建工投保
                    if (data.currentTaskName && data.currentTaskName == '信息驳回修改') { //去编辑
                        let obj = {}
                        let str = ''
                        obj.applicationNo = data.associateNo
                        let url = '/broker/insurance/application/detailByApplicationNo.admin'
                        let res = await this.$axios.post(url, obj)
                        let strUrl = '/haierProduct.html#/customized-employer-liability/fillin?id=' + res.insuranceApplicationId
                        if (res.taskId) str = str + '?taskId=' + data.taskId
                        window.open(strUrl)
                        this.loading = false
                    } else { //去详情
                        url = '/haierProduct.html#/my/taskDetail/' + data.associateNo + '?&taskName=' + data.currentTaskName
                        if (data.taskId) url = url + '&taskId=' + data.taskId
                        window.open(url)
                        this.loading = false
                    }
                } else if (data.workFlowType == 'BUILDER_EMPLOYER_ENDORSEMENT') { //建工批单
                    if (data.currentTaskName && data.currentTaskName == '信息驳回修改') { //去编辑
                        let obj = {}
                        obj.applicationNo = data.associateNo
                        url = '/agent.html#/agent/review/' + data.associateNo + '?&taskName=' + data.currentTaskName
                        if (data.taskId) url = url + '&taskId=0&formCustomized=1'
                        window.open(url)
                        this.loading = false
                    } else { //去详情
                        url = '/agent.html#/agent/review/' + data.associateNo + '?&taskName=' + data.currentTaskName
                        if (data.taskId) url = url + '&taskId=' + data.taskId
                        url = url + '&formCustomized=1'
                        console.log(url, 99999999999)
                        window.open(url)
                        this.loading = false
                    }
                }
            },
            async toDetail (data) {
                if (this.loading) return false
                this.loading = true
                let url = ''
                if (data.workFlowType == 'BUILDER_EMPLOYER_POLICY') { //建工投保
                    url = '/haierProduct.html#/my/taskDetail/' + data.associateNo + '?&taskName=' + data.currentTaskName
                    if (data.taskId) url = url + '&taskId=' + data.taskId
                    window.open(url)
                    this.loading = false
                } else if (data.workFlowType == 'BUILDER_EMPLOYER_ENDORSEMENT') { //建工投保批单
                    url = '/agent.html#/agent/review/detail/' + data.associateNo + '?endorseNo=' + data.associateNo + '&taskName=' + data.currentTaskName + '&taskId=0'
                    if (data.taskId) url = url + '&taskId=0'
                    url = url + '&formCustomized=1'
                    window.open(url)
                    this.loading = false
                }
            },
            // 检测登录
            checkLogin () {
                if (!this.userInfo.userId) {
                    if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                        window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                    }
                    return false
                } else {
                    return true
                }
            }
        }
    }
</script>
<style scoped>
    .content {
        padding: 0 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/task.vue